import { render, staticRenderFns } from "./conclusion.vue?vue&type=template&id=7a38ae4c&scoped=true&"
import script from "./conclusion.vue?vue&type=script&lang=js&"
export * from "./conclusion.vue?vue&type=script&lang=js&"
import style0 from "./conclusion.vue?vue&type=style&index=0&id=7a38ae4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38ae4c",
  null
  
)

export default component.exports